import React, { useRef, useState, useEffect } from "react";
import { Button, Card, Container, Row, Col } from "reactstrap";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import OrganizationService from "../../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import sebs from "../../../../assets/logo.png";
import { useParams } from "react-router-dom";
import './QrSmallModal.css'

export const QrSmallModal = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const qrCodeRef = useRef(null);
  const [data, setData] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const orgCode = user?.organizationInfo?.orgCode || data?.orgCode;
  const url = `${window.location.origin}/${data.orgCode}?source=qr-menu`;
const proxyUrl = `https://api.qrmenu.asia/api/proxy`;


  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const response = await OrganizationService.detail(id);
        setData(response);
        if (response?.cloudR2ImagePath) {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = response.cloudR2ImagePath.getCDNUrl();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            ctx.drawImage(img, 0, 0);
            const dataUrl = canvas.toDataURL("image/png");
            setImageSrc(dataUrl);
          };
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchDetail();
  }, [id]);

  const handlePrint = async () => {
    if (!modalRef.current) {
      console.error("Modal ref is not available");
      return;
    }

    try {
      const modalElement = modalRef.current;

      const canvas = await html2canvas(modalElement, {
        scale: 2,
        // useCORS: true,
        backgroundColor: "#f0f7ff",
        proxy: proxyUrl,
        logging: false,
      });

      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        alert('Please allow popups to print');
        return;
      }

      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100vh;
                  width: 100%;
                }
                img {
                  width: 100%;
                  height: auto;
                }
              }
            </style>
          </head>
          <body>
            <img src="${canvas.toDataURL('image/jpeg', 1.0)}" />
            <script>
              window.onload = function() {
                window.print();
                window.onafterprint = function() {
                  window.close();
                }
              }
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } catch (error) {
      console.error("Error printing:", error);
    }
  };

  const handleDownload = async () => {
    if (!modalRef.current) {
      console.error("Modal ref is not available");
      return;
    }

    try {
      setDownloading(true);

      const images = modalRef.current.querySelectorAll("img");
      await Promise.all(
        Array.from(images).map((img) => {
          return new Promise((resolve, reject) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = reject;
            }
          });
        })
      );

      const qrCodeCanvas = qrCodeRef.current.querySelector("canvas");
      const qrCodeImgSrc = qrCodeCanvas?.toDataURL("image/png");

      const clone = modalRef.current.cloneNode(true);
      const qrCodeDiv = clone.querySelector(".p-3.text-center");
      const qrCodeImg = document.createElement("img");
      qrCodeImg.src = qrCodeImgSrc;
      qrCodeImg.style.width = "100px";
      qrCodeImg.style.height = "100px";
      qrCodeImg.alt = "QR Code";
      qrCodeDiv.replaceChild(qrCodeImg, qrCodeDiv.firstChild);

      const logoImg = clone.querySelector("img[alt='Organization Logo']");
      if (logoImg && imageSrc) {
        logoImg.src = imageSrc;
      }

      clone.style.position = "absolute";
      clone.style.left = "-9999px";
      document.body.appendChild(clone);

      const canvas = await html2canvas(clone, {
        scale: 2,
        proxy: proxyUrl,
        // useCORS: true,
        backgroundColor: "#ffffff",
      });

      document.body.removeChild(clone);

      canvas.toBlob((blob) => {
        if (blob) {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${data?.name || "qr-code"}-menu.jpg`;
          link.click();
          URL.revokeObjectURL(link.href);
        }
        setDownloading(false);
      }, "image/jpeg");
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download image. Please try again.");
      setDownloading(false);
    }
  };

  return (
    <Container fluid className="py-4">
      <Row className="mb-4">
        <Col className="d-flex justify-content-end">
          <Button
            color="danger"
            onClick={() =>  navigate(`/organization/detail/${id}`)}
            className="d-print-none shadow-sm"
          >
            <i className="bx bx-arrow-back me-1"></i>
            Back
          </Button>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col xs="auto">
          <Card
            id="qr-card"
            innerRef={modalRef}
            className="border-0 shadow-sm bg-white"
            style={{
              width: "3.8in",
              height: "1.5in",
            }}
          >
            <Row className="g-0 h-100">
              <Col md="5" className="d-flex h-100 flex-column justify-content-center align-items-center border-end">
                <div
                  className="p-3 text-center h-100 d-flex flex-column justify-content-center align-items-center"
                  ref={qrCodeRef}
                >
                  <QRCodeCanvas
                    value={url}
                    size={300}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="H"
                    className="mb-2"
                    style={{ width: "100px", height: "100px" }}
                  />
                  <p className="fw-medium text-muted mb-0" style={{ fontSize: "10px" }}>
                    <i className="bx bx-scan me-1"></i>
                    Scan for Digital Menu
                  </p>
                </div>
              </Col>

              <Col md="7" className="d-flex flex-column gap-0  p-2 position-relative">

                <div className=" d-flex  justify-content-center align-items-center">
                  <div className=" d-flex  justify-content-center align-items-center " style={{height: "3rem"}}>
                    <img
                      src={imageSrc || data?.cloudR2ImagePath?.getCDNUrl()}
                      alt="Organization Logo"
                      className="me-2 small-qr-logo"
                    />
                  </div>
                  </div>

                <div>
                  <p className="fw-bold mb-0" style={{ fontSize: "12px" }}>{data?.name || ""}</p>
                  <div className="small" style={{ fontSize: "10px" }}>
                    <div className="d-flex align-items-center mb-1">
                      <i className="bx bx-map-pin me-2 text-primary"></i>
                      <span>{data?.address1 || ""}</span>
                    </div>
                    <div className="d-flex align-items-center mb-1">
                      <i className="bx bx-envelope me-2 text-primary"></i>
                      <span>{data?.email || ""}</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span>
                        <i className="bx bx-phone text-primary me-2"></i>
                        <span>{data?.contactNo || ""}</span>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-column text-end position-absolute p-3" style={{ bottom: "-0.9rem", right: "-0.5rem" }}>
                  <small className="text-muted mb-1" style={{ fontSize: "8px" }}>Powered by</small>
                  <img
                    src={sebs}
                    alt="SEBS Logo"
                    style={{ height: "16px", objectFit: "contain" }}
                    crossOrigin="anonymous"
                  />
                  <p className="text-muted mb-0" style={{ fontSize: "8px" }}>9843723855</p>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col className="d-flex justify-content-center gap-3">
          <Button
            color="primary"
            onClick={handlePrint}
            className="d-print-none shadow-sm"
          >
            <i className="bx bx-printer me-1"></i>
            Print QR Code
          </Button>
          <Button
            color="success"
            onClick={handleDownload}
            className="d-print-none shadow-sm"
            disabled={downloading}
          >
            <i className="bx bx-download me-1"></i>
            {downloading ? "Downloading..." : "Download as JPG"}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};